import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider, KeyboardDateTimePicker } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 160,
        maxWidth: 220,
    },
}));

export default function TimeFilter(props) {
    const classes = useStyles();
    const { label, filterName, setFilters } = props;
    const [selectedDateTime, setSelectedDateTime] = useState(null);

    const handleChange = (date) => {
        setSelectedDateTime(date);

        if (date !== null && date.isValid()) {
            setFilters(state => ({
                ...state,
                [filterName]: date.toISOString()
            }));
        }
    };

    return (
        <div className={classes.formControl}>
            <MuiPickersUtilsProvider utils={MomentUtils}>
                <KeyboardDateTimePicker
                    variant="inline"
                    autoOk={true}
                    disableFuture={true}
                    ampm={false}
                    invalidDateMessage={'Dagsetning/tími á röngu formi'}
                    label={label}
                    value={selectedDateTime}
                    onChange={handleChange}
                    format="DD-MM-YYYY HH:mm"
                />
            </MuiPickersUtilsProvider>
        </div>
    );
}